document.querySelectorAll('.flip-card__toggle')?.forEach((btn) => {
  btn.addEventListener('click', () => {
    const card = btn.closest('.flip-card__inner');
    const desc = card?.querySelector('.flip-card__desc');
    if (!desc) return;

    const isOpen = card.classList.toggle('is-active');

    desc.animate(
      [
        { opacity: isOpen ? 0 : 1 },
        { opacity: isOpen ? 1 : 0 }
      ],
      {
        duration: 300,
        easing: 'ease',
        fill: 'forwards'
      }
    );
  });
});